<template>
  <div class="row h-100">
    <div class="col-12 h-100 d-flex flex-column">
      <div v-if="!needToChooseTemplate" class="d-flex justify-content-end">
        <b-button
          v-if="!isNew && isMilestonePDF"
          v-b-modal="`generate-project-pdf-${id}`"
          variant="outline-primary"
          size="lg"
          class="px-4 mr-3"
          :disabled="isGenerating"
        >
          <b-spinner v-if="isGenerating" small />
          {{ isGenerating ? $translate('Generating') : $translate('Generate PDF') }}
        </b-button>
        <GenerateProjectPdfModal :project-id="id" :generatePDF="generatePDF" />
        <b-button v-if="!isNew && isMilestonePDF" variant="outline-primary" size="lg" class="px-4" @click="downloadPDF">
          {{ 'Download' | i18n }}
        </b-button>
        <b-button v-if="canEdit" variant="primary" size="lg" class="ml-3 px-4" :disabled="saveDisabled" @click="createProject">
          {{ 'save' | i18n }}
        </b-button>
      </div>
      <div class="poppins overflow-x-hidden overflow-auto mt-3 pt-1 pr-1 h-100" style="position: relative">
        <!-- <div class="small-id-text" v-if="id">ID: {{ id }}</div> -->
        <Loader v-if="!projectLoaded" />
        <div v-else>
          <div v-if="needToChooseTemplate" class="choose-template-block">
            <div class="choose-template-select">
              <Select v-model="selectedProjectTemplateID" :options="projectsList" form-group-id="Project Template" placeholder="Project Template" />
              <b-button
                variant="primary"
                size="lg"
                @click="chooseProjectTemplate"
                class="choose-template-next"
                :disabled="!selectedProjectTemplateID"
              >
                {{ 'Next' | i18n }}
              </b-button>
            </div>
          </div>
          <div v-else>
            <div>
              <BTabs pills card>
                <BTab :title="'Project Information' | i18n" active>
                  <ProjectInformation
                    :projectData="projectData"
                    :usersOptions="usersOptions"
                    :projectStatusOptions="projectStatusOptions"
                    :isCommonAdmin="isCommonAdmin"
                    :isNew="isNew"
                    :canEdit="canEdit"
                  />
                </BTab>
                <BTab :title="'Header Data' | i18n">
                  <HeaderData :projectData="projectData" :canEdit="canEdit" />
                </BTab>
                <BTab :title="'Sales order information' | i18n">
                  <SalesOrderInformation :projectData="projectData" :canEdit="canEdit" />
                </BTab>
                <BTab :title="'Machine' | i18n">
                  <Maschine :projectData="projectData" :canEdit="canEdit" />
                </BTab>
                <BTab :title="'Purchasing order' | i18n">
                  <PurchasingOrder :projectData="projectData" :canEdit="canEdit" />
                </BTab>
                <BTab :title="'Article' | i18n">
                  <Article :projectData="projectData" :canEdit="canEdit" />
                </BTab>
                <BTab :title="'Files' | i18n" v-if="!isNew">
                  <Files :projectData="projectData" :canEdit="canEdit" />
                </BTab>
              </BTabs>
            </div>
            <div class="fixed-block">
              <ChooseGroup :projectExist="!isNew" :loadProject="loadProject" :addMilestone="addMilestone" />
              <ChooseMilestone :projectExist="!isNew" :loadProject="loadProject" :addMilestone="addMilestone" />
              <BlockHeader :name="'milestones' | i18n" lg="12">
                <span v-if="isCommonAdmin || isSuperUser">
                  <b-button variant="primary" size="sm" @click="() => goToProjectMilestoneDetails(getID())" style="margin: -3px 0 0 10px">
                    {{ 'create_milestone' | i18n }}
                  </b-button>
                  <b-button variant="primary" size="sm" v-b-modal.choose-template style="margin: -3px 0 0 10px">
                    {{ 'choose_milestone_group' | i18n }}
                  </b-button>
                  <b-button variant="primary" size="sm" v-b-modal.choose-milestone style="margin: -3px 0 0 10px">
                    {{ 'choose_milestone' | i18n }}
                  </b-button>
                </span>
              </BlockHeader>
              <!-- <Table :columns="columns" :rows="projectData.milestones" /> -->
              <div>
                <div class="row mx-0 mile-header">
                  <div class="col-lg-1 col-sm-1 col-xs-1"></div>
                  <div class="col-lg-3 col-sm-3 col-xs-3">
                    {{ 'Milestone Name' | i18n }}
                  </div>
                  <div class="col-lg-3 col-sm-3 col-xs-3">
                    {{ 'Template' | i18n }}
                  </div>
                  <div class="col-lg-3 col-sm-3 col-xs-3">
                    {{ 'Project leader' | i18n }}
                  </div>
                  <div class="col-lg-2 col-sm-2 col-xs-2"></div>
                </div>
                <draggable
                  :list="projectData.milestones"
                  :group="{ name: 'milestones', put: false }"
                  handle=".handle"
                  :force-fallback="true"
                  :options="{ forceFallback: true }"
                >
                  <div v-for="mile in projectData.milestones" :key="mile.id">
                    <div class="row mx-0 mile-line">
                      <div class="col-lg-1 col-sm-1 col-xs-1 handle">
                        <span><BIconJustify /></span>
                      </div>
                      <div class="col-lg-3 col-sm-3 col-xs-3">
                        {{ mile.name }}
                      </div>
                      <div class="col-lg-3 col-sm-3 col-xs-3">
                        {{ mile.template ? mile.template.name : '-' }}
                      </div>
                      <div class="col-lg-3 col-sm-3 col-xs-3">
                        {{ mile.leader ? mile.leader.username : '-' }}
                      </div>
                      <div class="col-lg-2 col-sm-2 col-2">
                        <div class="copy-button mr-3" @click="() => goToProjectMilestoneDetails(mile.id)">
                          {{ 'Details' | i18n }}
                        </div>
                        <div class="copy-button delete-button" v-if="canEdit" @click="() => deleteMilestone(mile.id)">
                          {{ 'Delete' | i18n }}
                        </div>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { BTabs, BTab, BIconJustify } from 'bootstrap-vue';
import draggable from 'vuedraggable';
import axios from 'axios';

import Loader from '../../../common/loader';
import Input from '../../../common/input';
import Select from '../../../common/select';
import BlockHeader from '../../../common/block-header';
import Notification from '../../../common/notification';
import Table from '../../../common/table';

import { PROJECT_STATUSES, PROJECT_PDF_TYPES } from '../../../../../../../../constants';

import ChooseGroup from './components/choose-group';
import ChooseMilestone from './components/choose-milestone.vue';

import {
  ProjectsMixin,
  MachineOneMixin,
  CustomerMixinOne,
  ContactMixin,
  PartOneMixin,
  ReportsMixin,
  AuthStorageMixin,
  AuthMixin,
  DeleteRowMixin,
} from '../../../../../mixins';

import api from '../../../../api';
import { mapMilestonePayload } from '../milestone/helpers';

import HeaderData from './tabs/headerData.vue';
import SalesOrderInformation from './tabs/salesOrderInformation.vue';
import ProjectInformation from './tabs/projectInformation.vue';
import Maschine from './tabs/maschine.vue';
import PurchasingOrder from './tabs/purchasingOrder.vue';
import Article from './tabs/article.vue';
import Files from './tabs/files.vue';
import GenerateProjectPdfModal from './modals/pdf-generate-modal';

export default {
  title: 'New Project',
  components: {
    Loader,
    Input,
    Select,
    BlockHeader,
    Table,
    HeaderData,
    SalesOrderInformation,
    BTabs,
    BTab,
    ProjectInformation,
    Maschine,
    PurchasingOrder,
    Article,
    Files,
    ChooseGroup,
    BIconJustify,
    draggable,
    ChooseMilestone,
    GenerateProjectPdfModal,
  },
  mixins: [DeleteRowMixin, ProjectsMixin, MachineOneMixin, CustomerMixinOne, ContactMixin, PartOneMixin, ReportsMixin, AuthStorageMixin, AuthMixin],
  beforeRouteLeave(to, from, next) {
    if (this.disablePrevent) {
      return next();
    }
    const answer = window.confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
    if (answer) {
      this.clearProjects();
      next();
    } else {
      next(false);
    }
  },
  data() {
    return {
      id: '',
      isSaving: false,
      disablePrevent: true,
      projectStatusOptions: Object.values(PROJECT_STATUSES).map((i) => ({
        value: i,
        text: this.$translate(i),
      })),
      projectLoaded: false,
      projectData: {
        email: '',
        emailCC: '',
        milestones: [],
        headerData: {},
        salesOrderInformation: {},
        projectInformation: {
          status: PROJECT_STATUSES.ACTIVE,
        },
        maschine: {},
        purchasingOrder: {},
        article: {},
        isEmpty: null,
        selectedProjectTemplate: null,
      },
      templates: [],
      isNew: false,
      selectedProjectTemplateID: null,
      projectsList: [],
      users: [],
      usersOptions: [],
      isGenerating: false,
      intervalIndex: null,
    };
  },
  computed: {
    ...mapState({
      projects: (state) => state.project.projects,
    }),
    saveDisabled() {
      return !this.projectData.milestones.length || this.isSaving;
    },
    canEdit() {
      return this.isCommonAdmin || this.isSuperUser;
    },
    isMilestonePDF() {
      return this.projectData.milestones.some((m) => m.pdf);
    },
    needToChooseTemplate() {
      return !this.$route.query.isEmpty && this.isNew && !this.projectData.isEmpty && !this.projectData.selectedProjectTemplate;
    },
  },
  watch: {
    projectData: {
      handler: function () {
        if (this.projectLoaded) {
          this.disablePrevent = false;
        }
      },
      deep: true,
    },
  },
  async created() {
    this.id = this.$route.params.id;
    const isNew = this.$route.query.isNew;

    if (this.id && !isNew) {
      try {
        const project = await api.projects.getById(this.id);
        this.projectData = project;
        this.isNew = false;
      } catch (error) {
        Notification({ type: 'error', message: error.message });
      }
    } else if (this.id) {
      this.isNew = true;
      if (this.projects[this.id]) {
        this.projectData = this.projects[this.id];
        if (this.projects[this.id].changed) {
          this.disablePrevent = false;
        }
      }
    }

    if (!this.$route.query.isEmpty) {
      this.loadProjects();
    }

    this.generateProject();

    if (this.isNew) {
      await this.getSettings();
    }
  },
  methods: {
    ...mapActions({ setProject: 'project/setProject', clearProjects: 'project/clearProjects' }),
    async deleteMilestone(milestoneId) {
      await this.deleteSelectedRows(
        {},
        async () => {
          try {
            await api.projectMilestones.delete(milestoneId);
            this.projectData.milestones = this.projectData.milestones.filter(({ id }) => id !== milestoneId);
            Notification({ type: 'success', message: this.$translate('success') });
          } catch (err) {
            Notification({ type: 'error', message: err.message });
          }
        },
        false,
        'delete_milestone_message'
      );
    },
    downloadPDF() {
      const { access_token_link: token } = this.authStorageService.getAuth();
      window.open(`${axios.defaults.baseURL}/api/v1/one/project/${this.id}/pdf?authorization=${token}`, '_blank');
    },
    async generatePDF(language) {
      try {
        this.isGenerating = true;
        await api.projects.generatePDF({ id: this.id, language });
        this.intervalIndex = setInterval(async () => {
          const { projectPDF } = await api.projects.getById(this.id);

          if (projectPDF) {
            const { access_token_link: token } = this.authStorageService.getAuth();
            const url = `${axios.defaults.baseURL}/api/v1/one/project/${this.id}/projectPDF?authorization=${token}`;
            fetch(url)
              .then((resp) => resp.blob())
              .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = projectPDF;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
              })
              .catch((err) => {
                this.showNotification({ type: 'error', message: err.message });
              });
            clearInterval(this.intervalIndex);
            this.isGenerating = false;
            Notification({ type: 'success', message: this.$translate('file_has_been_downloaded_successful') });
          }
        }, 3000);
      } catch (error) {
        Notification({ type: 'error', message: error.message });
        this.isGenerating = false;
      }
    },
    async generateProject() {
      const replaceValue = ({ objectName, valueName }) => {
        if (this.projectData && this.projectData[objectName] && this.projectData[objectName][valueName]) {
          const p = this.projectData[objectName][valueName];
          if (typeof p === 'string') {
            this.projectData[objectName][valueName] = p;
          } else {
            this.projectData[objectName][valueName] = p.id || null;
          }
        }
      };

      replaceValue({ objectName: 'projectInformation', valueName: 'projectLeader' });
      replaceValue({ objectName: 'headerData', valueName: 'orderingCompany' });

      const response = await api.teams.getUsersLookup();
      this.users = response.data;
      this.usersOptions = this.users.map((item) => ({ value: item.id, text: item.username }));

      try {
        const templates = await this.projectsService.getTemplates();
        this.templates = templates.data;
      } catch (e) {
        this.templates = [];
      }

      this.projectData.milestones = this.projectData.milestones.map((m) => {
        if (m.milestoneData) {
          if (!m.name) {
            m.name = m.milestoneData.name;
          }
          if (!m.leader) {
            m.leader = m.milestoneData.leader;
          }

          if (!m.template) {
            m.template = this.templates.find((t) => t.id === m.milestoneData.templateId);
          }
        }
        return m;
      });

      setTimeout(() => {
        this.projectLoaded = true;
      }, 100);
    },
    async loadProject() {
      const project = await api.projects.getById(this.id);
      this.projectData.milestones = project.milestones;

      this.projectData.milestones = this.projectData.milestones.map((m) => {
        if (m.milestoneData) {
          if (!m.name) {
            m.name = m.milestoneData.name;
          }
          if (!m.leader) {
            m.leader = m.milestoneData.leader;
          }

          if (!m.template) {
            m.template = this.templates.find((t) => t.id === m.milestoneData.templateId);
          }
        }
        return m;
      });
    },
    async chooseProjectTemplate() {
      this.projectLoaded = false;
      const selectedProjectTemplate = await api.projects.getById(this.selectedProjectTemplateID);
      this.isNew = true;
      selectedProjectTemplate.id = this.$route.params.id;
      selectedProjectTemplate.milestones = selectedProjectTemplate.milestones.map((m) => ({
        ...m,
        id: this.getID(),
        isNew: true,
      }));
      selectedProjectTemplate.isEmpty = false;
      selectedProjectTemplate.selectedProjectTemplate = true;

      this.projectData = selectedProjectTemplate;
      await this.generateProject();
    },
    async loadProjects() {
      this.projectData.isEmpty = false;
      const projects = await api.projects.get();
      this.projectsList = projects.map((p) => ({ value: p.id, text: p.name || p.id }));

      if (this.projectsList.length === 0) {
        Notification({ type: 'error', message: 'No available templates' });
        this.projectData.isEmpty = true;
      }
    },
    async getSettings() {
      const settings = await api.settings.getSettings();

      if (!this.projectData.projectInformation.pdfType) {
        this.projectData.projectInformation.pdfType = settings.defaultProjectPdf;
      }
      this.projectData.headerData.orderingCompany = settings.defaultOrderingCompany;
    },
    addMilestone(m) {
      if (!m.name) {
        m.name = m.milestoneData.name;
      }
      if (!m.leader) {
        m.leader = m.milestoneData.leader;
      }

      if (!m.template) {
        m.template = m.milestoneData.template;
      }

      this.projectData.milestones.push(m);
    },
    goToProjectMilestoneDetails(milestoneId) {
      this.disablePrevent = true;
      const id = this.id;
      this.setProject({ project: this.projectData, id });
      this.$router.push({ name: 'milestone', params: { id, milestoneId } });
    },
    getID() {
      return `${Math.round(Math.random() * 10000)}_${new Date().getTime()}`;
    },
    async createProject() {
      this.disablePrevent = true;
      this.isSaving = true;

      try {
        const currentPdfType = this.projectData.projectInformation.pdfType;
        const currentOrderingCompany = this.projectData.headerData.orderingCompany;
        if (currentPdfType === PROJECT_PDF_TYPES.EGGERSMANN && !currentOrderingCompany) {
          throw new Error(this.$translate('Need to specify Ordering company'));
        }

        const projectBase = {
          headerData: this.projectData.headerData,
          salesOrderInformation: this.projectData.salesOrderInformation,
          projectInformation: this.projectData.projectInformation,
          maschine: this.projectData.maschine,
          purchasingOrder: this.projectData.purchasingOrder,
          article: this.projectData.article,
          email: this.projectData.email,
          emailCC: this.projectData.emailCC,
          status: this.projectData.status,
        };

        const replaceValue = ({ objectName, valueName }) => {
          const p = projectBase[objectName][valueName];
          if (typeof p === 'string') {
            projectBase[objectName][valueName] = p;
          } else {
            projectBase[objectName][valueName] = p ? p.id || null : null;
          }
        };

        replaceValue({ objectName: 'projectInformation', valueName: 'projectLeader' });
        replaceValue({ objectName: 'headerData', valueName: 'orderingCompany' });

        if (this.isNew) {
          const project = await api.projects.create(projectBase);

          const projectId = project.id;
          for (const index in this.projectData.milestones) {
            const milestone = this.projectData.milestones[index];
            const milestoneValue = milestone.milestoneData ? milestone.milestoneData : milestone;
            milestoneValue.templateId = milestone.templateId ? milestone.templateId : milestone.template.id;
            const fieldsValue = milestone.fieldsValue
              ? milestone.fieldsValue
              : {
                  ...milestone.report.fields,
                  ...milestone.fields,
                };

            const template = milestoneValue.template || this.templates.find((t) => t.id === milestoneValue.templateId);

            const params = {
              ...milestoneValue,
              project: projectId,
              fields: template.fields.map((f) => ({
                ...f,
                value: fieldsValue[f.key],
                isAttachFileToEmail: Object.hasOwn(this.fieldsValue || {}, `${f.key}_attachToEmail`)
                  ? fieldsValue[`${f.key}_attachToEmail`]
                  : f.isAttachFileToEmail,
              })),
              remoteSupport: milestoneValue.remoteSupport.map((c) => c.value || c.id),
              onSiteSupport: milestoneValue.onSiteSupport.map((c) => c.value || c.id),
            };
            const payload = mapMilestonePayload(params);
            await api.projectMilestones.create(payload);
          }
        } else {
          await api.projects.update({
            id: this.id,
            ...projectBase,
            milestones: this.projectData.milestones.map((m) => m.id),
          });
        }
        this.$router.go(-1);
        Notification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.disablePrevent = false;
        this.isSaving = false;

        Notification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
.main-content {
  overflow-y: visible;
  max-height: 100%;
  height: 100%;
}
.inputs-block {
  padding-left: 20px;
  padding-right: 20px;
}

.milestones-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.milestones-button {
  margin-right: 10px;
  margin-bottom: 20px;
  position: relative;
}

.fixed-block {
  position: sticky;
  top: 53px;
  background: white;
  z-index: 1000;
  padding-top: 1px;
}

.milestones-block {
  position: relative;
}

.delete-milestone {
  position: absolute;
  top: -28px;
  right: -1px;
  color: white;
  background: linear-gradient(#2260ff, #2260ff);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  text-align: center;
  line-height: 21px;
  border: 2px solid white;
  cursor: pointer;
}

::v-deep .tab-pane {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .card-header {
  background: white;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  cursor: pointer;
  max-width: 200px;
}

::v-deep .delete-button {
  color: #dc3545;
  border-color: #dc3545;
  background: rgba(220, 53, 69, 0.1);
}

::v-deep .action-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.choose-template-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 85vh;
  flex-direction: column;
}

.choose-template-button {
  margin: 10px;
  min-width: 200px;
}

.choose-template-select {
  .form-group {
    margin-bottom: 0px !important;
    min-width: 200px;
  }
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: flex-end;
  width: 300px;
}

.choose-template-next {
  margin-left: 30px;
  margin-bottom: 4px;
  line-height: 30px;
}

.mile-header {
  border-top: 1px solid rgb(238, 238, 238);
  border-bottom: 1px solid rgb(238, 238, 238);
  background: rgb(250, 250, 250);
  font-weight: 500;
  padding: 10px 0px;
}

.mile-line {
  border-bottom: 1px solid rgb(238, 238, 238);
  padding: 5px 0px;
  font-size: 14px;
  div {
    display: flex;
    align-items: center;
  }
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.handle {
  cursor: move;
  font-size: 21px;
}
</style>
